import { render, staticRenderFns } from "./GlobalFilterSideBar.vue?vue&type=template&id=a580d330&"
import script from "./GlobalFilterSideBar.vue?vue&type=script&lang=js&"
export * from "./GlobalFilterSideBar.vue?vue&type=script&lang=js&"
import style0 from "./GlobalFilterSideBar.vue?vue&type=style&index=0&id=a580d330&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports